import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const resetUserPassword = createAsyncThunk<void, { email: string }, { extra: Partial<Dependencies> }>(
  "users/resetUserPassword",
  async (body, { extra: { publicRepository } }) => {
    return publicRepository!.resetPassword(body);
  },
);
